// @flow

import React from 'react'
import { connect } from 'react-redux'
import { Button, Modal } from 'semantic-ui-react'
import { silver, prussian, white } from 'constants/inlineStyles'
import FlyerButton from '../../FlyerDetailMenu/components/FlyerButton'
import withMetricClick from '../../../withMetricClick'
import ModalContainer from './ModalContainer'
import CopyToClipboard from './CopyToClipboard'

const DIGITS_IN_STANDARD_PHONE_NUMBER = 10
let styles = {}

type ReduxStateProps = {|
  +value: ?string
|}

type Props = {|
  ...ReduxStateProps
|}

const formatPhoneNumberForDisplay = digitsOnlyPhoneNumber =>
  `(${digitsOnlyPhoneNumber.replace(/(\d{3})(\d{3})(\d+)/, '$1) $2-$3')}`

const CallProgramProviderModal = ({ value: senderPhoneNumber }: Props) => {
  const ButtonWithCallnowCopyMetric = withMetricClick(
    'callnow-modal-copy-number'
  )(Button)

  const ButtonWithCallnowMetric = withMetricClick('callnow')(FlyerButton)

  const phoneNumberDigitsOnly = senderPhoneNumber
    ? senderPhoneNumber.replace(/\D/g, '')
    : 'No Phone Number Provided'
  const phoneNumberForDisplay =
    phoneNumberDigitsOnly.length === DIGITS_IN_STANDARD_PHONE_NUMBER
      ? formatPhoneNumberForDisplay(phoneNumberDigitsOnly)
      : phoneNumberDigitsOnly
  return (
    <ModalContainer header="Call Organization">
      <Modal.Content style={styles.contentWrapper}>
        <div style={styles.phoneNumber}>{phoneNumberForDisplay}</div>
      </Modal.Content>
      {senderPhoneNumber && (
        <Modal.Actions style={styles.actions}>
          <CopyToClipboard clipboardContent={phoneNumberDigitsOnly}>
            <ButtonWithCallnowCopyMetric
              className="flyer-button"
              style={{ ...styles.button, ...styles.secondaryColors }}
            >
              Copy
            </ButtonWithCallnowCopyMetric>
          </CopyToClipboard>
          <ButtonWithCallnowMetric
            label="Call"
            type="action"
            style={styles.button}
            hrefAction={`tel:${phoneNumberDigitsOnly}`}
          />
        </Modal.Actions>
      )}
    </ModalContainer>
  )
}

styles = {
  largeSilverBorder: { border: `4px solid ${silver}` },
  phoneNumber: {
    fontWeight: 200,
    textAlign: 'center',
    width: '100%',
    fontSize: '22px',
    wordWrap: 'break-word'
  },
  button: {
    minWidth: '120px',
    border: `2px solid ${prussian}`,
    borderRadius: '.5em'
  },
  secondaryColors: {
    color: white,
    backgroundColor: prussian
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
  }
}

export default connect()(CallProgramProviderModal)



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerDetail/components/ModalManager/components/CallProgramProviderModal.js